var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{staticClass:"ui-textarea",attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }